import {
  LOAD_USER,
  CLEAR_USER
} from '../actions/user.js';

// user.js
function user(state = { hasCheckedStorage: false, companies: [] }, action) {
  switch (action.type) {
    case LOAD_USER:
      return Object.assign({}, state, action.data);
    case CLEAR_USER:
      return { hasCheckedStorage: false, companies: [] };
    default:
      return state;
  }
}

export default user;
